<template>
  <div class="b2c-order">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col
              class="d-flex justify-content-between align-items-center"
              cols="12"
          >
            <h4>Danh sách đơn hàng</h4>
          </b-col>
          <!-- Per Page -->
        </b-row>

        <b-row>
          <b-col cols="12">
            <vue-good-table
                :columns="fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :pagination-options="{
                perPage: serverParams.pageSize,
                enabled: true,
                perPageDropdown: [20, 50, 100],
                dropdownAllowAll: false,
              }"
                :rows="rows"
                :totalRows="totalRecords"
                mode="remote"
                @on-column-filter="onColumnFilter"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <b-dropdown
                      no-caret
                      size="sm"
                      toggle-class="text-decoration-none"
                      variant="link"
                  >
                    <template v-slot:button-content>
                      <feather-icon
                          class="text-body align-middle mr-25"
                          icon="MoreVerticalIcon"
                          size="16"
                      />
                    </template>
                    <b-dropdown-item @click="view(props.index)">
                      <feather-icon class="mr-50" icon="EyeIcon"/><span
                    >Xem chi tiết</span
                    >
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
                <span v-else-if="props.column.field === 'Id'">
                  <a class="text-primary" @click="view(props.index)">{{
                      props.row.Id
                    }}</a>
                </span>
                <span v-else-if="props.column.field === 'PolLcVehPremium'">
                  150.000.000
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
        id="modal-view"
        :title="'Mã đơn hàng ' + currentItem"
        ok-only
        size="xl"
    >
      <validation-observer ref="modalView">
        <b-row>
          <b-col cols="3">
            <h4>Thông tin khách hàng</h4>
            <b-card body-class="p-1">
              <b-card-text>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Tên khách hàng">
                      <b-form-input
                          v-model="pjico.FullName"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Điện thoại liên hệ">
                      <b-form-input
                          v-model="pjico.Phone"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Số giấy tờ">
                      <b-form-input
                          v-model="pjico.custId"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Địa chỉ">
                      <b-form-input
                          v-model="pjico.Address"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Email">
                      <b-form-input
                          v-model="pjico.Email"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
            <h4>Thông tin Xe</h4>
            <b-card body-class="p-1">
              <b-card-text>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Tên chủ xe">
                      <b-form-input
                          v-model="pjico.custName"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Địa chỉ thường trú">
                      <b-form-input
                          v-model="pjico.custAddress"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Loại xe">
                      <b-form-input
                          v-model="pjico.VehicleType"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Biển số">
                      <b-form-input
                          v-model="pjico.RegnNo"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Số khung">
                      <b-form-input
                          v-model="pjico.ChassisNo"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Số máy">
                      <b-form-input
                          v-model="pjico.EngineNo"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Số chỗ ngồi">
                      <b-form-input
                          v-model="pjico.SeatingCapacity"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Trọng tải hàng hóa">
                      <b-form-input
                          v-model="pjico.VehWeight"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="9">
            <h4>Thông tin thanh toán</h4>
            <b-card body-class="p-1">
              <b-card-text>
                <b-row class="pl-1">
                  <b-col cols="3">
                    <b-form-group label="Mã thanh toán">
                      <b-form-input
                          v-model="pjico.BankTranNo"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Kênh thanh toán">
                      <b-form-input
                          v-model="pjico.PaymentChannel"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Ngân hàng">
                      <b-form-input
                          v-model="pjico.BankCode"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Ngày tháng">
                      <b-form-input
                          :value="dateFormat(pjico.FinishDate)"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="pl-1">
                  <b-col cols="3">
                    <b-form-group label="Số tiền">
                      <b-form-input
                          v-model="pjico.Amount"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Trạng thái giao dịch">
                      <b-form-input
                          v-model="pjico.PaymentStatusName"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
            <h4>Thông tin gói bảo hiểm</h4>
            <b-card body-class="p-1">
              <b-card-text>
                <b-row class="pl-1">
                  <b-col cols="3">
                    <b-form-group label="Thời hạn gói BH">
                      <b-form-input
                          v-model="pjico.duration"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Ngày bắt đầu">
                      <b-form-input
                          v-model="pjico.polStartDate"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Ngày kết thúc">
                      <b-form-input
                          v-model="pjico.polEndDate"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Link HĐ">
                      <b-list-group>
                        <b-list-group-item :href="pjico.urlContract" target="_blank">{{
                            pjico.urlContract
                          }}
                        </b-list-group-item>
                      </b-list-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="pl-1">
                  <b-col cols="3">
                    <b-form-group label="Số tiền BH">
                      <b-form-input
                          v-model="pjico.polLcSi_NN"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Số LX/PX">
                      <b-form-input
                          v-model="pjico.NumOfDrivers"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Số tiền BH NHTX">
                      <b-form-input
                          v-model="pjico.PassagerLevelAmount"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Số người ngồi trên xe">
                      <b-form-input
                          v-model="pjico.NumOfPassagers"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
            <b-row class="pt-1 font-small">
              <b-col cols="12">
                <h5>Logs</h5>
                <b-card body-class="p-0" class="p-0">
                  <b-card-text style="overflow: auto">
                    <table class="table table-bordered table-sm">
                      <tr>
                        <th>Loại</th>
                        <th>Logs</th>
                        <th>Ngày</th>
                      </tr>
                      <tr>
                        <td>{{ pjico.LogType }}</td>
                        <td>{{ pjico.Content }}</td>
                        <td>{{ dateFormat(pjico.LogDate) }}</td>
                      </tr>
                    </table>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import 'vue-good-table/dist/vue-good-table.css'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BListGroup,
  BListGroupItem,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import SearchSelect from "../components/select/SearchSelect.vue";
import PopupCreateOrder from "./PopupCreateOrder.vue";
import {$ctx} from "@themeConfig";

export default {
  computed: {
    $ctx() {
      return $ctx;
    },
  },
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BListGroup,
    BListGroupItem,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BCardText,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    SearchSelect,
    PopupCreateOrder,
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  mounted() {
    this.getlistPjico()
  },
  watch: {
    serverParams: {
      handler: function (newVal, oldVal) {
        this.getlistPjico();
      },
      deep: true,
    },
  },
  methods: {
    dateFormat(v) {
      return moment(v, "YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm:ss");
    },
    onColumnFilter(params) {
      this.updateParams(params.columnFilters);
    },
    updateParams(newProps) {
      let newServerParamsFilter = {...this.serverParams.columnFilters, ...newProps};
      this.serverParams = Object.assign({}, this.serverParams, {columnFilters: newServerParamsFilter});
    },
    async onPerPageChange(params) {
      this.serverParams.pageSize = params.currentPerPage
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage
    },
    getlistPjico() {
      this.isLoading = true;
      useJwt.post('pjico/managerOrder', this.serverParams).then(response => {
        this.rows = response.data.result
        this.rows.forEach(e => {
          e.JSON = JSON.parse(e.JSON)
          this.statusList.forEach(i => {
            if (e.Status == i.id) {
              e.Status = i.text
            }

          })
          this.VehicleTypeList.forEach(i => {
            if (e.JSON.VehicleType == i.id) {
              e.JSON.VehicleType = i.text
            }

          })
          this.VehicleList.forEach(i => {
            if (e.JSON.Vehicle == i.id) {
              e.JSON.Vehicle = i.text
            }

          })
        })
        this.totalRecords = response.data.totalRecords;
        this.isLoading = false;
      }).catch(err => {
        console.log(err)
        this.isLoading = false;
      })
    },
    view(idx) {
      this.isLoading = true;
      this.currentItem = this.rows[idx].Id;
      this.loading(true);
      useJwt
          .get('pjico/orderDetail/' + this.currentItem)
          .then((response) => {
            this.pjico = response.data.result
            this.VehicleTypeList.forEach(i => {
              if (this.pjico.VehicleType == i.id) {
                this.pjico.VehicleType = i.text
              }

            })
            this.loading(false);
            this.$bvModal.show("modal-view");
            this.isLoading = false;
          })
          .catch((error) => {
            this.loading(false);
            this.isLoading = false;
          });
    },
  },
  data() {
    return {
      isEditPhoneEmail: false,
      searchString: "",
      isLoading: false,
      totalRecords: 0,
      rows: [],
      //dkttRows:[],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchTerm: "",
      pjico: [],
      currentItem: {},
      Cities: [],
      Districts: [],
      Partner: [],
      Wards: [],
      Stores: [],
      hamlets: [],
      isDisabledCreateOrder: false,
      fields: [
        {
          field: "Id",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Mã đơn hàng",
        },
        {
          field: "PartnerOrderId",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Hợp đồng",
        },
        {
          field: "CreateDate",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Ngày mua",
        },
        {
          field: "FullName",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Tên khách hàng",
        },
        {
          field: "JSON.Vehicle",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Loại bảo hiểm",
        },
        {
          field: "JSON.duration",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Thời hạn",
          tdClass: "text-center",
        },
        {
          field: "JSON.VehicleType",
          filterOptions: {enabled: true, placeholder: ""},
          label: "loại xe",
          tdClass: "text-center",
        },
        {
          field: "JSON.RegnNo",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Biển số xe/Số máy",
          tdClass: "text-center",
        },
        {
          field: "PolLcVehPremium",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Giá trị BH",
          tdClass: "text-center",
        },
        {
          field: "PaymentChannel",
          filterOptions: {enabled: true, placeholder: ""},
          label: "HTTT",
          tdClass: "text-center",
        },
        {
          field: "Status",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: 0, text: "Chưa thanh toán"},
              {value: 1, text: "Đã thanh toán/Chờ xác nhận"},
              {value: 2, text: "Đã xác nhận/Chuyển vận đơn"},
              {value: 3, text: "Hoàn thành giao hàng"},
              {value: 11, text: "Chờ Callboot xác nhận đơn COD"},
              {value: 90, text: "Lỗi thanh toán"},
              {value: 91, text: "Trả hàng"},
              {value: 92, text: "Hủy đơn"},
              {value: 93, text: "Đơn hủy từ Baseus"},
              {value: 300, text: "Khác"},
            ],
          },
          label: "Trạng thái TT",
        },
        {field: "action", label: "Thao tác",},
      ],
      statusList: [
        {id: 0, text: "Chưa thanh toán"},
        {id: 1, text: "Đã thanh toán/COD"},
        {id: 2, text: "Đã xác nhận/Chuyển vận đơn"},
        {id: 3, text: "Hoàn thành giao hàng"},
        {id: 11, text: "Chờ Callboot xác nhận đơn COD"},
        {id: 90, text: "Lỗi thanh toán"},
        {id: 91, text: "Trả hàng"},
        {id: 92, text: "Hủy đơn"},
        {id: 93, text: "Đơn hủy từ Baseus"},
        {id: 300, text: "Khác"},
      ],
      VehicleTypeList: [
        {id: "LX004.1", text: "Xe ô tô chở người"},
        {id: "LX005.1", text: "Xe ô tô chở hàng"},
        {id: "LX006.1", text: "Xe ô tô pickup, minivan"},
        {id: "LX007.1", text: "Xe ô tô cứu thương"},
        {id: "LX008.1", text: "Xe ô tô chở tiền"},
        {id: "LX009.1", text: "Xe ô tô đầu kéo, rơ moóc"},
        {id: "LX010.1", text: "Xe ô tô chuyên dùng khác"},
        {id: "LX011.2", text: "Xe máy chuyên dùng"},
        {id: "LX012.1", text: "Xe tập lái"},
        {id: "LX013.1", text: "Taxi"},
        {id: "LX014.1", text: "Xe buýt"},
        {id: "LX001.1", text: "Mô tô 2 bánh từ 50cc trở xuống"},
        {id: "LX001.2", text: "Mô tô 2 bánh trên 50cc"},
        {id: "LX002.1", text: "Mô tô 3 bánh"},
        {id: "LX003.1", text: "Xe máy điện"},
        {id: "LX003.2", text: "Các loại xe gắn máy còn lại"},
      ],
      VehicleList: [
        {id: 1, text: "Bảo hiểm xe máy"},
        {id: 2, text: "Bảo hiểm Ô tô"},
      ],
      serverParams: {
        columnFilters: {},
        page: 1,
        pageSize: 50,
        sortBy: {},
        sort: []
      },
      required,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.vgt-responsive {
  height: 700px;
}

.vgt-table {
  border-collapse: separate !important;
  border-spacing: 0
}

.vgt-table thead {
  position: sticky;
  top: 0px;
  background-color: white;
  z-index: 10
}

.list-group-item {
  padding: 0.188rem 0.857rem;
  color: blue;
  background-color: #efefef !important;
  text-decoration: underline;
}

.list-group-item:hover {
  background-color: #efefef !important;
  color: blue;
}

.vgt-responsive::-webkit-scrollbar {
  display: none;
}
</style>
<style>
.style-input {
  height: 100%;
}

.style-datepicker {
  width: 200px !important;
}

.b2c-order .vgt-wrap {
  /* max-height: calc(100vh - 300px); */
  overflow: auto;
}

.font-small .table-sm {
  font-size: 11px;
}

.col-gap-1 {
  column-gap: 1rem;
}
</style>
